// extracted by mini-css-extract-plugin
export default {"imgLabel":"SelectPalette_imgLabel__3Bt6-","img":"SelectPalette_img__oCWQ_"};